import createIcon from '../../createIcon';

/**
 * @component @name NetworkCell
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMiAyMkgyMlYyTDIgMjJaTTIwIDIwSDE3VjkuODNMMjAgNi44M1YyMFoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const NetworkCell = createIcon('NetworkCell', [
  ['path', { d: 'M2 22H22V2L2 22ZM20 20H17V9.83L20 6.83V20Z', key: '1h54qg' }],
]);

export default NetworkCell;
